<template>
  <div class="claim__documents">
      <LennocReceiptUpload
        :claimId="getClaimId"
        :documentId="documentId"
        :document="rootDocument"
        :environment="'portal'"
        :dropzoneStrings="getDropzoneStrings"
        :supportedFileTypes="getSupportedFileTypes"/>
    <LennocSpinner v-if="busy" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ClaimFileReceiptUpload',
  data () {
    return {
      busy: false,
      rootDocument: null
    }
  },
  props: {
    documentId: {
      type: String,
      default () {
        return ''
      }
    }
  },
  computed: {
    ...mapGetters({
      getClaimId: 'claim/claimId',
      getDocumentById: 'claim/getDocumentById',
      getDropzoneStrings: 'uistrings/getDropzoneStrings',
      getSupportedFileTypes: 'getSupportedFileTypes'
    }),
    documentFiles () {
      return this.getReceipts
    }
  },
  mounted () {
    if (this.documentId) {
      this.rootDocument = this.getDocumentById(this.documentId)
    }
  }
}
</script>
